import { ChartPlugin } from '../../_types'
import SpeedAbsorptionSummary from './_Component/SpeedAbsorptionRatioSummary'

const speedAbsorptionRatioSummaryPlugin: ChartPlugin = {
  Component: SpeedAbsorptionSummary,
}

export default speedAbsorptionRatioSummaryPlugin
